<template lang="pug">
  v-container
    portal(to="title")
      v-spacer
      v-btn.mr-4(
        color="primary"
        small
        :to=`{
          name: 'EducationCourseUnitList',
          params: routeParams,
        }`
      )
        span к курсу
        v-icon(right) mdi-arrow-right
    .d-flex.justify-center
      v-card.sdo-card.fill-width(
        max-width="950"
      )
        list-detail(
          v-if="contract"
          :item="contract"
          isEnrollment
        )
        v-skeleton-loader(
          v-else
          boilerplate
          width="950"
          type="table-heading, card,  card"
        )
</template>

<script>
import ListDetail from '@/modules/PaymentSystem/components/ListDetail.vue';

export default {
  components: { ListDetail },
  data() {
    return {
      contract: null,
    };
  },
  computed: {
    routeParams() {
      const { courseId } = this.$route.query;
      return { courseId };
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const params = {
        expand: 'users,transactions,qr_code,typical_contract_discount,typical_contract,preview_document,document,is_signed_executor,is_signed_customer',
      };
      const { item } = await this.$api.contracts.getContract(this.$route.params.id, params);
      this.contract = item;
    },
  },
};
</script>
